import React from "react";
import PropTypes from "prop-types";
import { BaasicFieldDropdown, BasicInput, NumericInput, BaasicButton, BaasicDropdown } from "core/components";
import { defaultTemplate } from "core/hoc";
import { Button } from "@progress/kendo-react-buttons";
import { uuid } from "core/utils";
import { PatientTemplateCustomOrderingDoctorAdd } from "application/niko-patient/components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { observer } from 'mobx-react';
import { orderingDoctorItemRender, orderingDoctorValueRender } from 'themes/components/select/OrderingDoctorDropdownRender';

const TooltipContent = observer(({ initianValue, history, fieldName }) => {
  if (!history || history.fieldName !== fieldName) return null;
  const date = new Date(history.eventDate + "Z");
  const formattedDate = date.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
  return (<div>
    <div>Previous: {initianValue ? initianValue : 'blank'}</div>
    <div style={{ fontSize: '11px', opacity: 0.75 }}>{history ? history.userName + ', ' + formattedDate : '-'}</div>
  </div>);
});

const NikoPatientTemplateClinicalEditTemplate = function ({ nikoPatientTemplateClinicalEditViewStore }) {
  const {
    form,
    clinicalStatusStore,
    missingDocumentStore,
    doctorStore,
    dxCode1Store,
    dxCode2Store,
    dxCode3Store,
    dxCode4Store,
    dxCode5Store,
    dxCode6Store,
    dxCode7Store,
    dxCode8Store,
    patientTemplate,
    updatePatientTemplate,
    updatePatient,
    openNikoTemplateMissingDocumentNoteModal,
    openPatientTemplateClinicalStatusNoteModal,
    pageViewStore,
    updatePatientData,
    disabledItem,
    updateClinicalStatus,
    generateMedicalNecessityFormAndStandardWrittenOrder,
    generateStandardWrittenOrder,
    generateMedicalNecessityForm,
    syncOrderingDoctors,
    isSyncInProgress,
    isPsoEditDisabled,
    isPso,
    canChangeClinicalStatus,
    getFieldHistory,
    item,
    missingDocsPreviousValue,
    mappedMissingDocuments,
    updateMissingDocuments,
  } = nikoPatientTemplateClinicalEditViewStore;

  const tagRender = (tagData, li) =>
    React.cloneElement(li, {
      children: <span key={uuid()} onClick={() => openNikoTemplateMissingDocumentNoteModal(tagData.data[0])}>{tagData.data[0].name}</span>,
    });

  const onTargetFocus = (e) => {
    e.target.select();
  };

  const initDxCode1 = isPso && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 1);
  const initDxCode2 = isPso && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 2);
  const initDxCode3 = isPso && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 3);
  const initDxCode4 = isPso && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 4);
  const initDxCode5 = isPso && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 5);
  const initDxCode6 = isPso && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 6);
  const initDxCode7 = isPso && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 7);
  const initDxCode8 = isPso && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes.find(x => x.Order === 8);

  const dxCode1 = isPso && patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 1);
  const dxCode2 = isPso && patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 2);
  const dxCode3 = isPso && patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 3);
  const dxCode4 = isPso && patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 4);
  const dxCode5 = isPso && patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 5);
  const dxCode6 = isPso && patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 6);
  const dxCode7 = isPso && patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 7);
  const dxCode8 = isPso && patientTemplate.patientTemplateDiagnosisCodes && patientTemplate.patientTemplateDiagnosisCodes.find(x => x.order === 8);

  const nikoInputData = isPso && { item: patientTemplate, patientTemplate: patientTemplate, getFieldHistory: getFieldHistory };
  const dxCodeDropdownItemRender = (li, itemProps) => {
    const itemName = itemProps && itemProps.dataItem.name;
    const itemChildren = (
      <span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
        <span style={{ flex: "1" }}> {li.props.children} </span>
        <span style={{ fontSize: "12px" }}>{itemName} </span>
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  }

  return (
    <div>
      <div className="modal__body u-mar--top--sml is-blue">
        <div className="row" style={{ flexWrap: "nowrap" }}>
          <div className="form__group col col-lrg-12">
            <div className="form__group__label">Missing Docs</div>
            <div className="u-position--rel">
              {!patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && missingDocsPreviousValue != null && (
                isPso ?
                  <React.Fragment>
                    <ReactTooltip positionStrategy="fixed" id={"registerTipMissingDocs" + patientTemplate.id} place="top" delayShow={600} render={() =>
                      <TooltipContent initianValue={missingDocsPreviousValue != null ? missingDocsPreviousValue : undefined} history={patientTemplate && patientTemplate.history} fieldName={"PatientTemplateMissingDocuments"} />} />
                    <i className="input--change--text opacity-50" data-tooltip-id={"registerTipMissingDocs" + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(patientTemplate, 'PatientTemplateMissingDocuments', patientTemplate.patientTemplateMissingDocuments && patientTemplate.patientTemplateMissingDocuments.map(x => x.missingDocumentId).join(','))} data-tooltip-content="" ></i>                             </React.Fragment>
                  :
                  <React.Fragment>
                    <ReactTooltip positionStrategy="fixed" id={"registerTipMissingDocs" + patientTemplate.id} place="top" />
                    <i data-tooltip-content={`Previous: ${missingDocsPreviousValue ? missingDocsPreviousValue : "blank"}`} data-tooltip-id={"registerTipMissingDocs" + patientTemplate.id} className='input--change--text' ></i>
                  </React.Fragment>
              )}
              <BaasicDropdown
                store={missingDocumentStore}
                value={mappedMissingDocuments ? mappedMissingDocuments.slice() : []}
                multi={true}
                tagRender={tagRender}
                autoClose={true}
                disabled={pageViewStore.disabled || isPsoEditDisabled}
                onChange={(e) => { updateMissingDocuments(e.target.value); }}
              />
            </div>
          </div>
          {patientTemplate.clinicalStatus && patientTemplate.clinicalStatus.name != "Covered" && patientTemplate.clinicalStatus.name != "Select" && patientTemplate.clinicalStatus.name != "Prior Auth Obtained" && patientTemplate.clinicalStatus.name != "Does Not Meet Insurance Criteria" && pageViewStore.nikoPatientDetail.eligibilityStatus && pageViewStore.nikoPatientDetail.eligibilityStatus.name === 'Eligible' &&
            <div className="u-flex--align-self-center">
              <Button className="btn btn--link u-mar--left--tny" icon="u-icon u-icon--med u-icon--us-note" data-tooltip-content="Clinical Status Note" onClick={() => openPatientTemplateClinicalStatusNoteModal()} disabled={pageViewStore.disabled || isPsoEditDisabled} />
            </div>
          }
          {pageViewStore.nikoPatientDetail.eligibilityStatus && pageViewStore.nikoPatientDetail.eligibilityStatus.name === 'Eligible' &&
            /* ISG-2622: post-Niko-Sales-Order the editable dropdown is replaced by a read-only clinical-status tag
               (mirroring the card header) with a swap icon to its right that opens the Change Clinical Status modal.
               The change-flag triangle is pinned to the tag's corner, as in the header. */
            (canChangeClinicalStatus && patientTemplate.nikoOrderId ?
              <div className="form__group col u-flex--align-self-end">
                <div className="u-flex--default">
                  <div className="is-blue u-position--rel">
                    {item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ClinicalStatusId != item.clinicalStatusId &&
                      <React.Fragment>
                        <ReactTooltip positionStrategy="fixed" id={"registerTipClinicalStatus" + patientTemplate.id} place="top" delayShow={600} render={() =>
                          <TooltipContent initianValue={patientTemplate.initialPatientTemplate.ClinicalStatusName} history={patientTemplate.history} fieldName={"ClinicalStatusId"} />} />
                        <i className="input--change--text opacity-50" data-tooltip-id={"registerTipClinicalStatus" + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(patientTemplate, 'ClinicalStatusId', item.clinicalStatusId)} data-tooltip-content=""></i>
                      </React.Fragment>
                    }
                    <BaasicButton
                      type='button'
                      className="btn btn--base btn--light btn--uppercase is-nonclickable"
                      key={patientTemplate.clinicalStatusId}
                      label={(patientTemplate.clinicalStatus && patientTemplate.clinicalStatus.name) || 'Unselected'}
                      disabled={!patientTemplate.clinicalStatusId}
                    />
                  </div>
                  <Button
                    className="btn btn--link btn--icon-hit"
                    icon="u-icon u-icon--med u-icon--synchronize--primary"
                    title="Change Clinical Status"
                    onClick={() => pageViewStore.openChangeClinicalStatusModal(patientTemplate, pageViewStore.nikoPatientDetail)}
                    disabled={pageViewStore.disabled}
                  />
                </div>
              </div>
              :
              <div className="form__group col u-flex--align-self-end">
                <div className="is-blue u-position--rel">
                  {item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ClinicalStatusId != item.clinicalStatusId &&
                    <React.Fragment>
                      <ReactTooltip positionStrategy="fixed" id={"registerTipClinicalStatus" + patientTemplate.id} place="top" delayShow={600} render={() =>
                        <TooltipContent initianValue={patientTemplate.initialPatientTemplate.ClinicalStatusName} history={patientTemplate.history} fieldName={"ClinicalStatusId"} />} />
                      <i className="input--change--text opacity-50" data-tooltip-id={"registerTipClinicalStatus" + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(patientTemplate, 'ClinicalStatusId', item.clinicalStatusId)} data-tooltip-content=""></i>
                    </React.Fragment>
                  }
                  <BaasicDropdown key={patientTemplate.clinicalStatusId} store={clinicalStatusStore} value={patientTemplate.clinicalStatusId} className="k-dropdown--primary k-dropdown--nowrap" onChange={(e) => { updateClinicalStatus(e.value) }} disabled={pageViewStore.disabled || disabledItem || isPsoEditDisabled} />
                </div>
              </div>
            )
          }
        </div>
        <div className="row" style={{ flexWrap: "nowrap" }}>
          <div className="form__group col col-lrg-8">
            <BasicInput
              field={form.$("salesOrderNote")}
              onBlur={() => { updatePatientTemplate("salesOrderNote"); }}
              disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.SalesOrderNote != item.salesOrderNote}
              nikoInputData={item && { ...nikoInputData, fieldName: 'SalesOrderNote', initialValue: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.SalesOrderNote, currentValue: item.salesOrderNote }}
            />
          </div>
          <div className="form__group col col-lrg-4">
            <BasicInput
              field={form.$("expirationDate")}
              onBlur={() => { updatePatientTemplate("expirationDate"); }}
              disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ExpirationDate != item.expirationDate}
              nikoInputData={item && { ...nikoInputData, fieldName: 'ExpirationDate', initialValue: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ExpirationDate, currentValue: item.expirationDate }}
            />
          </div>
          <div className="form__group col" style={{ width: "10%" }}>
            <label className="form__group__label">Generate Documents:</label>
            <div className="u-flex--default btn--grouped">
              <BaasicButton
                className="btn btn--sml btn--light u-mar--right--tny"
                icon="u-icon u-icon--sml u-icon--download--brand"
                label="SWO & PN"
                onlyIcon={true}
                disabled={pageViewStore.disabled || isPsoEditDisabled}
                onClick={() => generateMedicalNecessityFormAndStandardWrittenOrder()}
                isNiko={isPso}
              />
              <BaasicButton
                className="btn btn--sml btn--light u-mar--right--tny"
                label="SWO"
                disabled={pageViewStore.disabled || isPsoEditDisabled}
                onClick={() => generateStandardWrittenOrder()}
                isNiko={isPso}
              />
              <BaasicButton
                className="btn btn--sml btn--light u-mar--right--tny"
                label="PN"
                disabled={pageViewStore.disabled || isPsoEditDisabled}
                onClick={() => generateMedicalNecessityForm()}
                isNiko={isPso}
              />
              <PatientTemplateCustomOrderingDoctorAdd patientTemplate={patientTemplate} disabled={pageViewStore.disabled || isPsoEditDisabled} />
            </div>
          </div>
        </div>

        <div className="row u-mar--top--sml">
          <div className="col col-lrg-4">
            <div className="row" style={{ flexWrap: "nowrap" }}>
              <div className="form__group col col-lrg-8">
                <div className="form__group__label">
                  Ordering Doctor
                  <i title='Sync Niko Ordering Doctors' className={`u-icon u-icon--sml u-icon--synchronize--${isSyncInProgress ? "grey" : "primary"} u-mar--left--tny`} onClick={() => syncOrderingDoctors()}></i>
                </div>
                <BaasicFieldDropdown field={form.$("orderingDoctorId")} store={doctorStore} allowEmpty={true} labelDisplayed={false} disabled={pageViewStore.disabled || isPsoEditDisabled} itemRender={orderingDoctorItemRender} valueRender={orderingDoctorValueRender}
                  isNiko={isPso}
                  showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.OrderingDoctorId != item.orderingDoctorId}
                  nikoInputData={item && { ...nikoInputData, fieldName: 'OrderingDoctorId', initialValue: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.OrderingDoctorId, currentValue: item.orderingDoctorId, initialDisplayName: patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.DoctorName }}
                />
              </div>
              <div className="col col-lrg-2">
                <NumericInput
                  label="Height (in.)"
                  className="input--numeric"
                  min={0}
                  format={undefined}
                  disabled={pageViewStore.disabled || isPsoEditDisabled || disabledItem}
                  defaultValue={null}
                  value={pageViewStore.nikoPatientDetail.tempHeight}
                  spinners={false}
                  onClick={onTargetFocus}
                  onChange={(e) => { updatePatientData("tempHeight", e.target.value) }}
                  onBlur={() => { updatePatient(); }}
                  isNiko={isPso}
                  showChangeFlag={!patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && pageViewStore.nikoPatientDetail.initialNikoPatientDetail && pageViewStore.nikoPatientDetail.initialNikoPatientDetail.Height != pageViewStore.nikoPatientDetail.height}
                  nikoInputData={{ ...nikoInputData, item: pageViewStore.nikoPatientDetail, fieldName: 'Height', initialValue: pageViewStore.nikoPatientDetail.initialNikoPatientDetail.Height, currentValue: pageViewStore.nikoPatientDetail.height }}
                />
              </div>
              <div className="col col-lrg-2">
                <NumericInput
                  label="Weight (lbs.)"
                  className="input--numeric"
                  min={0}
                  format={undefined}
                  disabled={pageViewStore.disabled || isPsoEditDisabled || disabledItem}
                  defaultValue={null}
                  value={pageViewStore.nikoPatientDetail.tempWeight}
                  spinners={false}
                  onClick={onTargetFocus}
                  onChange={(e) => { updatePatientData("tempWeight", e.target.value) }}
                  onBlur={() => { updatePatient(); }}
                  isNiko={isPso}
                  showChangeFlag={!patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && pageViewStore.nikoPatientDetail.initialNikoPatientDetail && pageViewStore.nikoPatientDetail.initialNikoPatientDetail.Weight != pageViewStore.nikoPatientDetail.weight}
                  nikoInputData={{ ...nikoInputData, item: pageViewStore.nikoPatientDetail, fieldName: 'Weight', initialValue: pageViewStore.nikoPatientDetail.initialNikoPatientDetail.Weight, currentValue: pageViewStore.nikoPatientDetail.weight }}
                />
              </div>
            </div>
          </div>
          <div className="col col-lrg-1">
            <BaasicFieldDropdown field={form.$("dxCode1")} store={dxCode1Store} itemRender={dxCodeDropdownItemRender} allowEmpty={true} disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && (initDxCode1 ? initDxCode1.DiagnosisCodeId : '') != (dxCode1 ? dxCode1.diagnosisCodeId : '')}
              nikoInputData={item && { ...nikoInputData, fieldName: 'DxCode1', initialValue: initDxCode1 && initDxCode1.DiagnosisCode && initDxCode1.DiagnosisCode.code, currentValue: dxCode1Store.value && dxCode1Store.value.id }}
            />
          </div>
          <div className="col col-lrg-1">
            <BaasicFieldDropdown field={form.$("dxCode2")} store={dxCode2Store} itemRender={dxCodeDropdownItemRender} allowEmpty={true} disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && (initDxCode2 ? initDxCode2.DiagnosisCodeId : '') != (dxCode2 ? dxCode2.diagnosisCodeId : '')}
              nikoInputData={item && { ...nikoInputData, fieldName: 'DxCode2', initialValue: initDxCode2 && initDxCode2.DiagnosisCode && initDxCode2.DiagnosisCode.code, currentValue: dxCode2Store.value && dxCode2Store.value.id }}
            />
          </div>
          <div className="col col-lrg-1">
            <BaasicFieldDropdown field={form.$("dxCode3")} store={dxCode3Store} itemRender={dxCodeDropdownItemRender} allowEmpty={true} disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && (initDxCode3 ? initDxCode3.DiagnosisCodeId : '') != (dxCode3 ? dxCode3.diagnosisCodeId : '')}
              nikoInputData={item && { ...nikoInputData, fieldName: 'DxCode3', initialValue: initDxCode3 && initDxCode3.DiagnosisCode && initDxCode3.DiagnosisCode.code, currentValue: dxCode3Store.value && dxCode3Store.value.id }}
            />
          </div>
          <div className="col col-lrg-1">
            <BaasicFieldDropdown field={form.$("dxCode4")} store={dxCode4Store} itemRender={dxCodeDropdownItemRender} allowEmpty={true} disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && (initDxCode4 ? initDxCode4.DiagnosisCodeId : '') != (dxCode4 ? dxCode4.diagnosisCodeId : '')}
              nikoInputData={item && { ...nikoInputData, fieldName: 'DxCode4', initialValue: initDxCode4 && initDxCode4.DiagnosisCode && initDxCode4.DiagnosisCode.code, currentValue: dxCode4Store.value && dxCode4Store.value.id }}
            />
          </div>
          <div className="col col-lrg-1">
            <BaasicFieldDropdown field={form.$("dxCode5")} store={dxCode5Store} itemRender={dxCodeDropdownItemRender} allowEmpty={true} disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && (initDxCode5 ? initDxCode5.DiagnosisCodeId : '') != (dxCode5 ? dxCode5.diagnosisCodeId : '')}
              nikoInputData={item && { ...nikoInputData, fieldName: 'DxCode5', initialValue: initDxCode5 && initDxCode5.DiagnosisCode && initDxCode5.DiagnosisCode.code, currentValue: dxCode5Store.value && dxCode5Store.value.id }}
            />
          </div>
          <div className="col col-lrg-1">
            <BaasicFieldDropdown field={form.$("dxCode6")} store={dxCode6Store} itemRender={dxCodeDropdownItemRender} allowEmpty={true} disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && (initDxCode6 ? initDxCode6.DiagnosisCodeId : '') != (dxCode6 ? dxCode6.diagnosisCodeId : '')}
              nikoInputData={item && { ...nikoInputData, fieldName: 'DxCode6', initialValue: initDxCode6 && initDxCode6.DiagnosisCode && initDxCode6.DiagnosisCode.code, currentValue: dxCode6Store.value && dxCode6Store.value.id }}
            />
          </div>
          <div className="col col-lrg-1">
            <BaasicFieldDropdown field={form.$("dxCode7")} store={dxCode7Store} itemRender={dxCodeDropdownItemRender} allowEmpty={true} disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && (initDxCode7 ? initDxCode7.DiagnosisCodeId : '') != (dxCode7 ? dxCode7.diagnosisCodeId : '')}
              nikoInputData={item && { ...nikoInputData, fieldName: 'DxCode7', initialValue: initDxCode7 && initDxCode7.DiagnosisCode && initDxCode7.DiagnosisCode.code, currentValue: dxCode7Store.value && dxCode7Store.value.id }}
            />
          </div>
          <div className="col col-lrg-1">
            <BaasicFieldDropdown field={form.$("dxCode8")} store={dxCode8Store} itemRender={dxCodeDropdownItemRender} allowEmpty={true} disabled={pageViewStore.disabled || isPsoEditDisabled}
              isNiko={isPso}
              showChangeFlag={item && !patientTemplate.isNew && !pageViewStore.nikoPatientDetail.isNew && (initDxCode8 ? initDxCode8.DiagnosisCodeId : '') != (dxCode8 ? dxCode8.diagnosisCodeId : '')}
              nikoInputData={item && { ...nikoInputData, fieldName: 'DxCode8', initialValue: initDxCode8 && initDxCode8.DiagnosisCode && initDxCode8.DiagnosisCode.code, currentValue: dxCode8Store.value && dxCode8Store.value.id }}
            />
          </div>
        </div>
      </div>
    </div >
  );
};

NikoPatientTemplateClinicalEditTemplate.propTypes = {
  nikoPatientTemplateClinicalEditViewStore: PropTypes.object.isRequired,
};

export default defaultTemplate(NikoPatientTemplateClinicalEditTemplate);

